module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_en.bcfe1644.png";